import React, { useRef, useEffect, useState } from 'react';
import { APIProvider, Map, useMap } from '@vis.gl/react-google-maps';

const MapController = ({ onMapReady, onMapChange }) => {
  const map = useMap()
  
  useEffect(() => {
    if (map && onMapReady) {
      onMapReady(map)
      
      const updateMapState = () => {
        const center = map.getCenter()
        const zoom = map.getZoom()
        const bounds = map.getBounds()
        onMapChange({ center: center.toJSON(), zoom, bounds })
      }
      
      // Listen to multiple events for faster updates
      const centerListener = map.addListener('center_changed', updateMapState)
      const zoomListener = map.addListener('zoom_changed', updateMapState)
      const boundsListener = map.addListener('bounds_changed', updateMapState)
      
      return () => {
        centerListener.remove()
        zoomListener.remove()
        boundsListener.remove()
      }
    }
  }, [map, onMapReady, onMapChange])
  
  return null
}

const BaseMap = ({ 
  onMapReady, 
  onMapChange, 
  onClick,
  selectedUnit 
}) => {
  
  return (
    <APIProvider apiKey="AIzaSyAHTahZ-YiuC_C-EH33zuLfo2pY0S-f3Y8">
      <Map
        defaultCenter={{ lat: 36.132235, lng: -5.352273 }}
        defaultZoom={5}
        disableDefaultUI={true}
        clickableIcons={false}
        onClick={onClick}
        style={{ width: '100%', height: '100%' }}
      >
        <MapController onMapReady={onMapReady} onMapChange={onMapChange} />
      </Map>
    </APIProvider>
  )
}

export default React.memo(BaseMap, (prevProps, nextProps) => {
  // Only re-render if selectedUnit changes
  return prevProps.selectedUnit === nextProps.selectedUnit
})